import uuidv4 from 'uuid/dist/v4';

import customLocalStorage from 'Utils/customLocalStorage';

export const DISTINCT_ID_KEY = 'crehana_user_distinct_id';

function getUserDistinctId(): {
  // distinctId is the uuid string.
  distinctId: string;
  // wasRecentlyCreated is a boolean that will be true if it has created a new token and it will be false if the token already exists and come from localstorage.
  wasRecentlyCreated: boolean;
} {
  /**
   * We must get the user uuid from localstorage.
   * If its not there We will create a new one and store it in localStorage
   * Remember to delete this localStorage key after the user log-out
   */
  const distinctId = customLocalStorage.getItem(DISTINCT_ID_KEY);

  if (distinctId) {
    return { distinctId, wasRecentlyCreated: false };
  }

  const newDistinctId = uuidv4();

  customLocalStorage.setItem(DISTINCT_ID_KEY, newDistinctId);
  window.distinctUserIdWasRecentlyCreated = true;

  return { distinctId: newDistinctId, wasRecentlyCreated: true };
}

export default getUserDistinctId;
